angular.module( 'acme.view.application.pos.create.images', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.images.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreateImages = {
        name: 'application.pos.create.images',
        url: '/splash',
        views: {
          "subview-main": {
            controller: 'PosCreateImagesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/images/images.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      },
      posEditImages = {
        name: 'application.pos.edit.images',
        url: '/splash',
        views: {
          "subview-main": {
            controller: 'PosCreateImagesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/images/images.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      };

    $stateProvider
      .state(posCreateImages)
      .state(posEditImages);
});
